export const tooltipStyles = {
  tooltip: {
    maxWidth: "300px",
    backgroundColor: "black",
    color: "white",
    fontSize: "13px",
    padding: "8px 12px",
    borderRadius: "6px",
  },
  arrow: {
    color: "black",
  },
};
